import React from 'react'
import Img from './Img'

interface QuoteAuthorProps {
  img: string
  title: string
  from: string
}

const QuoteAuthor: React.FC<QuoteAuthorProps> = ({ img, title, from }) => {
  return (
    <div className="flex flex-row items-center">
      <div className="inline-block w-14 lg:w-20 h-14 lg:h-20 mr-8 overflow-hidden rounded-full md:mr-4 md:w-12 md:h-12">
        <Img src={img} className="grayscale" />
      </div>
      <div className="flex-row text-sm leading-loose md:flex">
        <span className="font-medium">{from}</span>
        <span className="inline-block px-2">-</span>
        <span>{title}</span>
      </div>
    </div>
  )
}

export default QuoteAuthor
